/** Now as RFC 3339 in UTC, to the second: 2026-11-04T02:30:00Z. */
export function nowIso(): string {
  return new Date().toISOString().replace(/\.\d{3}Z$/, "Z");
}

/** "2 цагийн өмнө", "өчигдөр", "11/02" */
export function relativeMn(iso: string, now = Date.now()): string {
  const t = new Date(iso).getTime();
  const min = Math.round((now - t) / 60_000);
  if (min < 1) return "дөнгөж сая";
  if (min < 60) return `${min} минутын өмнө`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} цагийн өмнө`;
  const d = Math.round(h / 24);
  if (d === 1) return "өчигдөр";
  if (d < 7) return `${d} өдрийн өмнө`;
  const date = new Date(t);
  return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}`;
}
